"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_189_48729",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "1",
  width: "16",
  height: "14",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1ZM7.0996 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2Z",
  fill: "#000001"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 6c-.5523 0-1 .4477-1 1v5c0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1H3Zm10 1H3v5h10V7Z",
  fill: "#000001"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2Z",
  fill: "#000001"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.218 2.092C0 2.5198 0 3.08 0 4.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C1.5198 15 2.08 15 3.2 15h9.6c1.1201 0 1.6802 0 2.108-.218a1.9996 1.9996 0 0 0 .874-.874C16 13.4802 16 12.9201 16 11.8V4.2c0-1.1201 0-1.6802-.218-2.108a1.9997 1.9997 0 0 0-.874-.874C14.4802 1 13.9201 1 12.8 1H3.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874ZM12.8 2H3.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1.0001 1.0001 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4218C1.0007 3.2512 1 3.6235 1 4.2v7.6c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0494.0252.1502.0629.4218.0851.2834.0231.6557.0239 1.2322.0239h9.6c.5766 0 .9488-.0008 1.2322-.0239.2716-.0222.3723-.0599.4218-.0851a.9998.9998 0 0 0 .437-.437c.0252-.0495.0629-.1502.0851-.4218.0231-.2834.0239-.6556.0239-1.2322V4.2c0-.5766-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.085C13.7488 2.0007 13.3766 2 12.8 2Z",
  fill: "#000001"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_189_48729)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#131619",
  d: "M0 0h16v16H0z"
}))], 'IconZoomWebinarIcon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconZoomWebinar';
var _default = SvgIcon;
exports["default"] = _default;